import {
  AfterContentInit,
  Component,
  ElementRef,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewEncapsulation,
  inject,
  input,
} from '@angular/core';
import { SolutionModel } from '@app/src/app/modules/solution/classes/default/model/solution.model';
import { RenderHtml, Translation } from '@ckmk/angular';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'solution-card',
  standalone: true,
  imports: [Translation, RenderHtml, RouterLink],
  templateUrl: './solution-card.html',
  styleUrl: './solution-card.scss',
  host: {
    '[tabindex]': '0',
  },
  encapsulation: ViewEncapsulation.None,
})
export class SolutionCard
  implements OnInit, OnChanges, OnDestroy, AfterContentInit
{
  private readonly self = inject<ElementRef<HTMLElement>>(ElementRef);

  public readonly item = input.required<SolutionModel>();

  public constructor() {}

  public ngOnInit(): void {
    this.initContent();
  }

  public ngOnChanges({ item }: SimpleChanges) {
    if (item && !item.firstChange) {
      this.initContent();
    }
  }

  public ngOnDestroy(): void {}

  public ngAfterContentInit(): void {}

  protected getImg(): string {
    return this.item().picture?.defaultUrl || '';
  }

  protected initContent(): void {
    const category = this.item().category;

    if (category) {
      this.self.nativeElement.style.setProperty(
        '--color-category-left',
        category.data?.leftColor || '',
      );
      this.self.nativeElement.style.setProperty(
        '--color-category-right',
        category.data?.rightColor || '',
      );
    }
  }
}
